<img src="./assets/media/svg/icons/General/Edit-3.svg" placement="bottom" title="Edit" (click)="invokeParentMethod()">
 &nbsp;
<span *ngIf="displayRelation"> <img src="./assets/media/svg/icons/General/Dependency.svg" title="Manage Dependency" (click)="invokeRelationMethod()"></span>


